module.exports = __webpack_public_path__ + "img/bana_5kl.1c674f03.jpg";